<template>
  <div class="admin-panel">
    <!-- هدر پنل -->
    <header class="admin-header">
      <div class="admin-nav">
        <h1>پنل مدیریت سایت ورزشی</h1>
        <div class="nav-links">
          <button
              v-for="tab in tabs"
              :key="tab.id"
              :class="['nav-btn', activeTab === tab.id ? 'active' : '']"
              @click="activeTab = tab.id"
          >
            {{ tab.name }}
          </button>
        </div>
      </div>
    </header>

    <div class="admin-content">
      <!-- آمار کلی -->
      <div v-if="activeTab === 'dashboard'" class="dashboard">
        <div class="stats-grid">
          <div class="stat-card">
            <h3>تعداد اخبار</h3>
            <p class="stat-number">{{ stats.newsCount || 0 }}</p>
          </div>
          <div class="stat-card">
            <h3>تعداد مسابقات</h3>
            <p class="stat-number">{{ stats.matchesCount || 0 }}</p>
          </div>
          <div class="stat-card">
            <h3>تعداد تیم‌ها</h3>
            <p class="stat-number">{{ stats.teamsCount || 0 }}</p>
          </div>
        </div>

        <button @click="seedData" class="seed-btn">
          افزودن داده تستی
        </button>
      </div>

      <!-- مدیریت اخبار -->
      <div v-if="activeTab === 'news'" class="news-management">
        <div class="section-header">
          <h2>مدیریت اخبار</h2>
          <button @click="showNewsForm = true" class="btn-primary">
            افزودن خبر جدید
          </button>
        </div>

        <!-- فرم افزودن خبر -->
        <div v-if="showNewsForm" class="news-form">
          <h3>افزودن خبر جدید</h3>
          <form @submit.prevent="addNews">
            <input v-model="newNews.title" placeholder="عنوان خبر" required>
            <textarea v-model="newNews.summary" placeholder="خلاصه خبر" required></textarea>
            <textarea v-model="newNews.content" placeholder="متن کامل خبر"></textarea>
            <input v-model="newNews.category" placeholder="دسته‌بندی">
            <input v-model="newNews.imageUrl" placeholder="آدرس عکس">
            <label>
              <input type="checkbox" v-model="newNews.isHot"> خبر داغ
            </label>
            <div class="form-actions">
              <button type="submit">ذخیره</button>
              <button type="button" @click="cancelNewsForm">انصراف</button>
            </div>
          </form>
        </div>

        <!-- لیست اخبار -->
        <div class="news-list">
          <div
              v-for="news in newsList"
              :key="news.id"
              class="news-item"
          >
            <div class="news-info">
              <h4>{{ news.title }}</h4>
              <p>{{ news.summary }}</p>
              <span class="news-meta">{{ news.category }} • {{ formatDate(news.createdAt) }}</span>
            </div>
            <div class="news-actions">
              <button @click="editNews(news)">ویرایش</button>
              <button @click="deleteNews(news.id)" class="btn-danger">حذف</button>
            </div>
          </div>
        </div>
      </div>

      <!-- مدیریت مسابقات -->
      <div v-if="activeTab === 'matches'" class="matches-management">
        <h2>مدیریت مسابقات</h2>
        <p>این بخش به زودی اضافه می‌شود...</p>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '../services/api'

export default {
  name: 'AdminPanel',
  data() {
    return {
      activeTab: 'dashboard',
      tabs: [
        { id: 'dashboard', name: 'داشبورد' },
        { id: 'news', name: 'اخبار' },
        { id: 'matches', name: 'مسابقات' },
        { id: 'teams', name: 'تیم‌ها' }
      ],
      stats: {},
      newsList: [],
      showNewsForm: false,
      newNews: {
        title: '',
        summary: '',
        content: '',
        category: '',
        imageUrl: '',
        isHot: false
      }
    }
  },
  methods: {
    async loadStats() {
      try {
        this.stats = await apiService.adminGetStats()
      } catch (error) {
        console.error('Error loading stats:', error)
      }
    },

    async loadNews() {
      try {
        this.newsList = await apiService.adminGetNews()
      } catch (error) {
        console.error('Error loading news:', error)
      }
    },

    async addNews() {
      try {
        await apiService.adminCreateNews(this.newNews)
        this.showNewsForm = false
        this.resetNewsForm()
        this.loadNews() // رفرش لیست
        alert('خبر با موفقیت اضافه شد')
      } catch (error) {
        console.error('Error adding news:', error)
        alert('خطا در افزودن خبر')
      }
    },

    async deleteNews(id) {
      if (confirm('آیا از حذف این خبر مطمئنید؟')) {
        try {
          await apiService.adminDeleteNews(id)
          this.loadNews() // رفرش لیست
          alert('خبر با موفقیت حذف شد')
        } catch (error) {
          console.error('Error deleting news:', error)
          alert('خطا در حذف خبر')
        }
      }
    },

    editNews(news) {
      // بعداً پیاده‌سازی می‌شود
      alert('ویرایش خبر: ' + news.title)
    },

    cancelNewsForm() {
      this.showNewsForm = false
      this.resetNewsForm()
    },

    resetNewsForm() {
      this.newNews = {
        title: '',
        summary: '',
        content: '',
        category: '',
        imageUrl: '',
        isHot: false
      }
    },

    async seedData() {
      try {
        await apiService.adminSeedData()
        this.loadStats()
        this.loadNews()
        alert('داده تستی با موفقیت اضافه شد')
      } catch (error) {
        console.error('Error seeding data:', error)
      }
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDate('fa-IR')
    }
  },
  watch: {
    activeTab(newTab) {
      if (newTab === 'dashboard') {
        this.loadStats()
      } else if (newTab === 'news') {
        this.loadNews()
      }
    }
  },
  mounted() {
    this.loadStats()
  }
}
</script>

<style scoped>
.admin-panel {
  direction: rtl;
  font-family: 'Vazirmatn', sans-serif;
  background: #f5f7f9;
  min-height: 100vh;
}

.admin-header {
  background: #1e3a8a;
  color: white;
  padding: 1rem 0;
}

.admin-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-links {
  display: flex;
  gap: 10px;
}

.nav-btn {
  background: transparent;
  border: 1px solid rgba(255,255,255,0.3);
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
}

.nav-btn.active,
.nav-btn:hover {
  background: #3b82f6;
  border-color: #3b82f6;
}

.admin-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

/* داشبورد */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  text-align: center;
}

.stat-number {
  font-size: 2rem;
  font-weight: bold;
  color: #1e3a8a;
  margin: 10px 0 0 0;
}

.seed-btn {
  background: #10b981;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
}

/* مدیریت اخبار */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.btn-primary {
  background: #3b82f6;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
}

.btn-danger {
  background: #dc2626;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
}

.news-form {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.news-form input,
.news-form textarea {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: 'Vazirmatn', sans-serif;
}

.news-form textarea {
  height: 100px;
  resize: vertical;
}

.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.news-item {
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.news-info {
  flex: 1;
}

.news-info h4 {
  margin: 0 0 10px 0;
  color: #1f2937;
}

.news-info p {
  margin: 0 0 10px 0;
  color: #6b7280;
  font-size: 0.9rem;
}

.news-meta {
  font-size: 0.8rem;
  color: #9ca3af;
}

.news-actions {
  display: flex;
  gap: 10px;
}
</style>